import { ModelFactory } from '@angular-extensions/model';
import { Subject } from 'rxjs';
import { IShortListItem } from '../models/common-model';
import * as i0 from "@angular/core";
import * as i1 from "@angular-extensions/model";
const initialData = [];
export class ShortListService {
    constructor(_modelFactory, _modelFactoryFilters) {
        this._modelFactory = _modelFactory;
        this._modelFactoryFilters = _modelFactoryFilters;
        this._toBasket = new Subject();
        this._reset = new Subject();
        this._viewTypeChanging = false;
        this.toBasket$ = this._toBasket.asObservable();
        this.reset$ = this._reset.asObservable();
        this._model = this._modelFactory.create(initialData);
        this.active$ = this._model.data$;
        this._modelFilters = this._modelFactoryFilters.create(null);
        this.activeFilters$ = this._modelFilters.data$;
    }
    get currentActive() {
        return this._model.get();
    }
    add(items) {
        const vModels = this._model.get();
        var hasUpdates = false;
        items.forEach(item => {
            var o = vModels.findIndex(vModel => vModel.id === item.id && vModel.type === item.type && vModel.cc === item.cc); //ToDo V ?add item.modelGroups[0].modelsId
            if (o < 0) {
                hasUpdates = true;
                vModels.push(item);
            }
        });
        if (hasUpdates)
            this._model.set(vModels);
    }
    remove(items) {
        const vModels = this._model.get();
        var hasUpdates = false;
        items.forEach(item => {
            var o = vModels.findIndex(vModel => vModel.id === item.id && vModel.type === item.type && vModel.cc === item.cc); //ToDo V ?add item.modelGroups[0].modelsId
            if (o > -1) {
                hasUpdates = true;
                vModels.splice(o, 1);
            }
        });
        if (hasUpdates)
            this._model.set(vModels);
    }
    restoreIsSelected(items) {
        const vModels = this._model.get();
        items.forEach(item => {
            var o = vModels.findIndex(vModel => vModel.id === item.id
                && (vModel.type === item.type || vModel.type === item.derivativeType)
                && (vModel.cc === item.cc || vModel.cc === item.countryCode)); //ToDo V ?add item.modelGroups[0].modelsId
            if (o > -1) {
                item.isSelected = true;
            }
        });
    }
    reset() {
        const vModels = this._model.get();
        vModels.length = 0;
        this._model.set(vModels);
        this._reset.next(true);
    }
    exist(item) {
        const vModels = this._model.get();
        var o = vModels.findIndex(vModel => vModel.id === item.id
            && ( /*vModel.type === item.type ||*/vModel.type === item.derivativeType)
            && ( /*vModel.cc === item.cc ||*/vModel.cc === item.countryCode));
        return o > -1;
    }
    addToBasket() {
        const vModels = this._model.get();
        this._toBasket.next(vModels);
    }
    addToBasketFilter(searchFilters) {
        this._modelFilters.set(searchFilters);
    }
    resetFilter() {
        this._modelFilters.set(null);
    }
    get viewTypeChanging() {
        return this._viewTypeChanging;
    }
    set viewTypeChanging(value) {
        this._viewTypeChanging = value;
    }
}
ShortListService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ShortListService_Factory() { return new ShortListService(i0.ɵɵinject(i1.ModelFactory), i0.ɵɵinject(i1.ModelFactory)); }, token: ShortListService, providedIn: "root" });
